import React from 'react';
import { cn } from "../../lib/utils";

interface SkeletonProps {
  className?: string;
  variant?: 'default' | 'avatar' | 'text' | 'button';
}

export const Skeleton: React.FC<SkeletonProps> = ({ 
  className,
  variant = 'default'
}) => {
  return (
    <div
      className={cn(
        'animate-pulse bg-gray-200 dark:bg-gray-700 rounded',
        variant === 'avatar' && 'rounded-full',
        variant === 'text' && 'h-4 w-full',
        variant === 'button' && 'h-9 rounded-md',
        className
      )}
    />
  );
};
